/**
 * @Author: HJK
 * @Date: 2023-05-27 11:03:51
 * @LastEditTime: 2023-09-01 10:02:31
 * @LastEditors: HJK
 * @Description: 
 * @FilePath: \badayuan-frontend\src\utils\msg.js
 */


//type=>success/warning/info/error	
const codeByType = {
    '200': 'success',
    '400': 'error',
}

import { Message } from "element-ui";
export default (res, customConfig = {}) => {
    const { code, msg } = res;
    const type = customConfig.type || codeByType['' + code] || 'warning';
    Message({
        type,
        message: msg,
        showClose: true,
        ...customConfig
    })
}


// WEBPACK FOOTER //
// ./src/utils/msg.js